import TourneeFormWrapper from "../../components/tournee/TourneeFormWrapper";

const TourneeEdit = () => {
  return <TourneeFormWrapper action="edit" />;
};

export default TourneeEdit;
